import { Directive, ElementRef, Input, OnInit, OnChanges, Renderer2, HostBinding, ContentChildren,SimpleChanges, QueryList, AfterViewInit } from '@angular/core';
//import { MediaCell } from 'angular-framework-client-components/components/media-cell/'
import { ScrollingHelperService } from 'angular-engine/engine/service/ui/scrolling/scrolling.helper.service';

@Directive({
    selector: '[slide-position]'
})
export class SlidePositionDirective implements OnInit {

     @Input() defaultFocusPosition : number = 2;
     @Input() defaultItemMargin : number = 5;
     @Input() focusedItemRightMargin :number = 35;
     @Input() focusedItem : any;
     @Input() inScopeItems: Array<any> = [];
     @ContentChildren("cells", { descendants: true, read: ElementRef}) cells: QueryList<ElementRef>;
    protected focusedInScopeIndex :number    = 0;
    protected augmentedWidth : number = 0;
    protected widthArr : Array<number>;    
    protected widthConfig : any = {
      "Episode" : 44
    }
    protected lefts : Array<any>
    constructor(
        private el: ElementRef,
        protected scrollHelper: ScrollingHelperService,
        protected renderer: Renderer2
    ){
        this.scrollHelper.renderer = renderer;
    }

    ngOnInit(){
       
       
    }

    ngAfterViewInit(){
        this.positionSlides()
    }

    protected positionSlides() : void {
        
        if(this.cells){
            this.updateOnFocusChange()
        }
    }
    ngOnChanges( changes : SimpleChanges ){
        if ( changes.inScopeItems  &&  changes.inScopeItems.currentValue && changes.inScopeItems.firstChange ){
            this.widthArr = this.inScopeItems.map( item => { 
                let width : number =  this.widthConfig[ item.meta.obj_type ];
                return width;
            });
        } 

        if (changes.focusedItem && changes.focusedItem.currentValue){
          this.focusedInScopeIndex = this.inScopeItems.indexOf( this.focusedItem );
          this.positionSlides();
        }
    }
    
    
    
    protected updateAugmentedWidth(index) : number{
     const counter = this.focusedInScopeIndex - index;
     let widthArr  = this.widthArr.filter((item, index, arr) =>{
       return  counter > index
     });
     
     if( widthArr.length > 0 ){
       this.augmentedWidth = widthArr.reduce((left, newLeft) =>{
         return newLeft ? newLeft + left  : 0; 
       });
     }
     
     return this.augmentedWidth;
    }

    protected updateOnFocusChange(  ) : void {
        const directive = this;
        let focusItemAugmentedPosition = 0;
        let currentFocusedIndex = this.focusedInScopeIndex;
        let currentFocusedItem = this.inScopeItems[currentFocusedIndex];
        let left : number = 0;
        let holder : Array<number> = [];
        let isAugmentedWidthSet : boolean;
        directive.lefts = directive.cells.map(( width, index, arr ) => {
          const prevWidth : number = directive.widthArr[index -1] ? directive.widthArr[index -1] : 0;
          const prevLeft : number =  holder[index-1] ? holder[index -1] : directive.defaultFocusPosition;

          if (  index == 0  || (index > 0 && currentFocusedIndex > 0 && index < currentFocusedIndex )){
            if( currentFocusedIndex == 0){
              left = directive.defaultFocusPosition 
            }else{
              left = directive.defaultFocusPosition  - directive.updateAugmentedWidth( index);
            }
          }else if ( index == currentFocusedIndex ){
            left = this.defaultFocusPosition
          }else if( index  == currentFocusedIndex +1){
            left  = prevLeft + prevWidth + directive.focusedItemRightMargin;
          }else if( index > 0 && index > (currentFocusedIndex +1) ){
            left  = prevLeft + prevWidth ;
          }
    
    
          const temp = left;
          
          holder.push (temp);
          return  temp;
        });
        
        if ( directive.cells  ) {
            directive.cells.forEach((item, index, arr)  => {
                //item.nativeElement.setAttribute( "style" , "transform: translateX( " +  directive.lefts[index] + "vw);" );
                this.renderer.setAttribute(item.nativeElement, "style","transform:translateX( " +  directive.lefts[index] + "vw);");
            });
        }
      }

      public translateItem ( i : number ) : string {
        return 'translateX(' + this.lefts[i] + 'vw)'
      }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/slide-position.directive.ts